import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "gutterSpacing", "gutterSpacingVertical", "gutterSpacingHorizontal"];
import React, { forwardRef, useMemo } from 'react';
import { useGridClassName } from './utils';
import { GRID_CLASS_PREFIX, gridRoot } from './constants';
import { GridContext } from './utils/GridContext';
import { GridRoot } from './style';
import { useComponentTheme } from '../../utils/hooks';
export var Grid = forwardRef(function Grid(_ref, ref) {
  var className = _ref.className,
      gutterSpacing = _ref.gutterSpacing,
      gutterSpacingVertical = _ref.gutterSpacingVertical,
      gutterSpacingHorizontal = _ref.gutterSpacingHorizontal,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(GRID_CLASS_PREFIX);
  var classOverride = useGridClassName(GRID_CLASS_PREFIX, className);
  var contextValue = useMemo(function () {
    return {
      gutterSpacing: gutterSpacing,
      gutterSpacingVertical: gutterSpacingVertical,
      gutterSpacingHorizontal: gutterSpacingHorizontal
    };
  }, [gutterSpacing, gutterSpacingVertical, gutterSpacingHorizontal]);
  return React.createElement(GridContext.Provider, {
    value: contextValue
  }, React.createElement(GridRoot, Object.assign({
    "data-testid": gridRoot
  }, restProps, {
    className: classOverride.Root,
    gutterSpacing: gutterSpacing,
    gutterSpacingVertical: gutterSpacingVertical,
    gutterSpacingHorizontal: gutterSpacingHorizontal,
    ref: ref,
    theme: theme
  })));
});
Grid.defaultProps = {
  gutterSpacing: 0
};